var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.789,
    height: 25.784,
    viewBox: "0 0 21.789 25.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.688)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M205.4,112.683a3.772,3.772,0,1,1-3.773,3.772,3.776,3.776,0,0,1,3.773-3.772m0-1.935a5.706,5.706,0,1,0,5.706,5.706,5.707,5.707,0,0,0-5.706-5.706Z",
    transform: "translate(-199.693 -110.748)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.423)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M215.97,135.028H195.181v-.966a10.395,10.395,0,0,1,20.789,0Zm-18.8-1.934h16.812a8.461,8.461,0,0,0-16.812,0Z",
    transform: "translate(-195.181 -123.667)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlue);
export default __webpack_public_path__ + "static/media/user_blue.13e6f638.svg";
export { ForwardRef as ReactComponent };